export const getSwitzerlandData = () => ({
  name: "Suisse",
  description: "La Suisse est un pays viticole traditionnel avec une diversité de terroirs exceptionnelle, du lac Léman aux Alpes. Le pays produit des vins de qualité, principalement consommés localement, avec des cépages autochtones uniques comme le Chasselas et le Pinot Noir.",
  type: "country",
  regions: [
    { name: "Valais", area: "5,000 ha", percentage: "33%", description: "Plus grande région" },
    { name: "Vaud", area: "3,800 ha", percentage: "25%", description: "Chasselas emblématique" },
    { name: "Genève", area: "1,400 ha", percentage: "9%", description: "Vins urbains" },
    { name: "Tessin", area: "1,000 ha", percentage: "7%", description: "Vins italiens" },
    { name: "Autres", area: "4,000 ha", percentage: "26%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Valais", x: 7.5, y: 46.2, color: "#4B164C", size: 6 },
    { region: "Vaud", x: 6.5, y: 46.5, color: "#6d2c7a", size: 5 },
    { region: "Genève", x: 6.2, y: 46.2, color: "#8a4a8a", size: 3 },
    { region: "Tessin", x: 8.8, y: 46.0, color: "#a768a6", size: 3 }
  ],
  statistics: {
    totalArea: "15,200 ha",
    production: "1.1 million hectolitres",
    regions: "5 régions principales",
    appellations: "15+ appellations",
    exportPercentage: "5%"
  },
  characteristics: {
    climate: "Climat continental avec influences alpines et lacustres",
    soil: "Sols calcaires, argileux, granitiques, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Vins rouges élégants et structurés, principalement Pinot Noir",
    white: "Vins blancs secs et minéraux, Chasselas emblématique",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture suisse remonte à l'époque romaine. Les moines ont développé les techniques viticoles au Moyen Âge. La Suisse a une tradition viticole millénaire, avec des cépages autochtones comme le Chasselas. Aujourd'hui, la Suisse produit des vins de qualité, principalement consommés localement.",
  foodPairing: "Cuisine suisse traditionnelle : fondue, raclette, rösti, chocolat. Les vins suisses s'accordent parfaitement avec la cuisine locale et les fromages affinés."
}); 